<template lang="pug">
  section.p_contact#contact
    .c_inner
      .p_contact-header
        h2.p_contact-heading.c_heading1._fade.fade_in.scale
          span.p_contact-heading-text.c_heading1-text Contact
        .p_contact-descript._fade.fade_in.scale
          p ALHでは一緒に働く仲間を募集しています。
            br.u_bl-sp
            |オフィスに遊びに来ませんか？？
      .p_contact-body
        ul.p_contact-list.c_col-pc.u_col-jc-sb
          li.p_contact-list-item(v-for="(item, key) in contact")
            a.p_contact-btn(:href="item.url", :target="item.target", v-touch:tap="tap")
              span.p_contact-btn-text(v-html="item.text")
</template>

<script>
  export default {
    name: 'TheContact',
    data () {
      return {
        contact: [
          { text: '採用サイトはこちら',
            url: 'https://recruit.alhinc.jp/',
            target: '_blank'
          },
          { text: 'オフィスについてのお問い合わせはこちら',
            url: 'https://www.alhinc.jp/contact',
            target: '_blank'
          },
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
.p_contact {
  @include pc {
    padding: rem(76) 0 rem(120);
  }
  @include sp {
    padding: rem(116,2) 0 rem(120,2);
  }
  background: #eeeeee;

  &-header {
    @include pc {
      margin: 0 0 rem(50);
    }
    @include sp {
      margin: 0 0 rem(60,2);
    }
    text-align: center;
  }

  &-heading {
    &-text {
      @include pc {
        font-size: rem(64);
      }
      @include sp {
        font-size: vw(64,750);
      }
      letter-spacing: .4em;
    }
  }

  &-descript {
    @include pc {
      margin: rem(50) 0 0;
      font-size: rem(20);
    }
    @include sp {
      margin: rem(50,2) 0 0;
      font-size: rem(16);
    }
    letter-spacing: $ltsp;

    p {
      @include pc {
        line-height: (42/20);
      }
    }
  }

  &-body {
    @include pc {
      margin: rem(55) 0 0;
    }
  }

  &-list {
    &-item {
      @include pc {
        width: calc(50% - 4px);
        min-width: calc(50% - 4px);
      }

      &:not(:first-child) {
        @include sp {
          margin: rem(30) 0 0;
        }
      }
    }
  }

  &-btn {
    @include pc {
      padding: rem(42) rem(20);
    }
    @include sp {
      padding: rem(25) rem(20);
    }
    color: $color;
    width: 100%;
    display: block;
    text-align: center;
    background: $palet2;
    border: 4px solid $palet2;

    &.tap {
      color: #d4c600;
      background: #fff;
    }

    &-text {
      @include pc {
        font-size: rem(18);
      }
      @include sp {
        font-size: rem(14);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top/TheContact.vue